import api from "@dyl/apiClients/backendApi/api";

export default async function getConfigs(level_id) {
    const { data } = await api.get(`levels/${level_id}/configs`, {});
    return data;
}